import { getMessages } from '../../../../../../../store/constants';
import { CUSTOM_PROPERTY_TYPES } from '../CustomPropertyTypeSelect/constants';
import { ECustomPropertyType } from '../../../../../../../store/customProperties/types';

export const CARD_CUSTOM_FORM_PLACEHOLDER_FOCUS = getMessages().getText('card_form_custom_placeholder');
export const CARD_CUSTOM_FORM_OPTION_PLACEHOLDER = getMessages().getText('card_form_custom_option');
export const CARD_CUSTOM_FORM_OPTION_PLACEHOLDER_FOCUS = getMessages().getText('card_form_custom_option_placeholder');
export const CARD_CUSTOM_SELECT_DEFAULT_OPTIONS_COUNT = 1;
export const CUSTOM_BUTTON_REMOVE_TOOLTIP = getMessages().getText('common.remove');
export const CUSTOM_ERROR_DUPLICATE = getMessages().getText('card_form_custom_section_error_duplicated');
export const CUSTOM_ERROR_EMPTY = getMessages().getText('card_form_custom_section_error_empty');

export const getPropertyPlaceholder = (type: ECustomPropertyType) => {
    return `${CUSTOM_PROPERTY_TYPES.find(item => item.value === type).name} ${getMessages().getText('card_form_custom_property')}`
}
